<script lang="ts" setup>
/* App List Item Component
 *
 * This component renders a single app item in the sidebar list of the notification popper.
 */
import Badge from '@/v1/components/Badge.vue';


const props = defineProps<{
    active: boolean;
    name: string;
    icon: string;
    count?: number
}>();

</script>
<template>
    <div class="panel lan:p-2.5 lan:flex lan:flex-row lan:items-center lan:gap-[5px] lan:cursor-pointer lan:select-none"
        :class="{ 'lan:sm:bg-blue-50': props.active }">
        <img :src="props.icon" class="lan:w-6 lan:h-6" />
        <div class="lan:m-0 lan:flex-1 lan:text-ellipsis lan:overflow-hidden lan:whitespace-nowrap">{{
            props.name }}</div>
        <div v-if="props.count && props.count > 0">
            <Badge variant="large">{{ props.count }}</Badge>
        </div>
    </div>
</template>